import * as DialogPrimitive from "@radix-ui/react-dialog";
import styled from "styled-components";

import { Button as StyledButton } from "components/atoms/Button";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 100vw;
    max-height: 95vh;
    overscroll-behaviour: contain;
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }

    ${device.md} {
        max-width: 50vw;
        max-height: 90vh;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    width: 100%;
    flex: 1;

    ${device.md} {
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
    }
`;

export const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    flex: 1;

    img {
        object-fit: cover;
        width: 100%;
        height: auto;
        border-radius: 0.5rem;
    }

    ${device.md} {
        width: 40%;
        max-width: 40vw;
    }
`;

export const HighlightText = styled.p`
    background: ${colourScheme.secondary};
    color: ${colourScheme.white};
    padding: 0.5rem;
    border-radius: 0.5rem;
    font-weight: bold;
    text-wrap: pretty;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
`;

export const ShareContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;
`;

export const Icon = styled.div`
    display: inline-block;
    cursor: pointer;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
`;

export const Button = styled(StyledButton)`
    margin: 0rem;
`;

export const ModalOverlay = styled(DialogPrimitive.Overlay)`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(0.25rem);
    z-index: 9999 !important;
`;

export const ModalContent = styled(DialogPrimitive.Content)`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000 !important;
    width: 100%;
    max-width: 32rem;
    animation: scale-in 0.3s ease-in-out;

    @keyframes scale-in {
        0% {
            transform: translate(-50%, -50%) scale(0.95);
            opacity: 0;
        }
        100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
    }
`;
